import React, { useEffect } from 'react';
import './users.css';
import http from '../../services/http-service'
import { DataGrid } from '@mui/x-data-grid';
import MenuItem from '@mui/material/MenuItem';
import FormControl from '@mui/material/FormControl';
import Select from '@mui/material/Select';
import { ToastContainer } from 'react-toastify';

const rows = [
  { id: 1, col1: 'Hello', col2: 'World', col3: 'World', col4: 'World', col5: 'World' },
  { id: 2, col1: 'DataGridPro', col2: 'is Awesome', col3: 'World', col4: 'World', col5: 'World' },
  { id: 3, col1: 'MUI', col2: 'is Amazing', col3: 'World', col4: 'World', col5: 'World' },


];

const columns = [
  { field: 'col1', headerName: 'First Name', resizable: true,
  width: 270,  },
  { field: 'col2', headerName: 'Last Name',  resizable: true,
  width: 270},
  { field: 'col3', headerName: 'User ID',  resizable: true,
  width: 270 },
  { field: 'col4', headerName: 'Location', resizable: true,
  width: 270},
  { field: 'col5', headerName: 'Status',  resizable: true,
  width: 270 },
];


function Users() {
  // render() {
  useEffect(() => {
    http('admin/view_admin_user_list/', 'GET')
      .then(res => {

        if (res.data.status) {
          console.log('employee data is as ::', res.data);
        }

        else {
          // toast.error(res.message)
        }

      },
        err => {
          console.log('err....', err)
        });

  });

 

  return (
    <div className='commonPageDiv'>
      <ToastContainer />
      <div className='AccordionDiv'>
        <FormControl className='AccordionDivForm'>
          <Select className='AccordionDivSelect'
            displayEmpty
            inputProps={{ 'aria-label': 'Without label' }}>
              <span className='defaultSelect'>None</span>
              <MenuItem value="None" className='AccordionDivMenu'>
                 None 
              </MenuItem>
              <MenuItem value={10}>Ten</MenuItem>
              <MenuItem value={20}>Twenty</MenuItem>
              <MenuItem value={30}>Thirty</MenuItem>
          </Select>
        </FormControl>
      </div>
      <div style={{ height: 300, width: '100%'}} className='DataTable'>
        <DataGrid rows={rows} columns={columns} className='tableDataGrid' />
      </div>

      
    </div>
  )
  // }
}

export default Users;
